import { FC } from 'react';
import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import { FormattedMessage } from 'dibs-react-intl';

import { DeactivatedQuoteExplanation_shipmentQuote$data as ShipmentQuote } from './__generated__/DeactivatedQuoteExplanation_shipmentQuote.graphql';

type Props = {
    shipmentQuote: ShipmentQuote;
};

const APPLICABLE_TO_ANY = '*';

const getExplanationMessage = ({
    state,
    zipCode,
    country,
}: {
    state?: string | null;
    zipCode?: string | null;
    country?: string | null;
}): React.ReactElement => {
    if (state === APPLICABLE_TO_ANY && zipCode === APPLICABLE_TO_ANY) {
        return (
            <FormattedMessage
                id="checkout.DeactivatedQuotes.label.applicableToCountry"
                defaultMessage="(only applicable to {country})"
                values={{ country }}
            />
        );
    } else if (state === APPLICABLE_TO_ANY) {
        return (
            <FormattedMessage
                id="checkout.DeactivatedQuotes.label.applicableToCountryAndZipCode"
                defaultMessage="(only applicable to {country} and {zipCode})"
                values={{ country, zipCode }}
            />
        );
    } else if (zipCode === APPLICABLE_TO_ANY) {
        return (
            <FormattedMessage
                id="checkout.DeactivatedQuotes.label.applicableToCountryAndState"
                defaultMessage="(only applicable to {country} {state})"
                values={{ country, state }}
            />
        );
    }

    // default message when there's no asterisk (both state and zipCode have a value)
    return (
        <FormattedMessage
            id="checkout.DeactivatedQuotes.label.applicableToStateAndZipCode"
            defaultMessage="(only applicable to {state} {zipCode})"
            values={{ state, zipCode }}
        />
    );
};

const DeactivatedQuoteExplanation: FC<Props> = ({ shipmentQuote }) => {
    const { state, zipCode, country } =
        shipmentQuote?.serviceMethod?.region?.regionBoundary?.locations?.[0] || {};

    return getExplanationMessage({ state, zipCode, country });
};

export default createFragmentContainer(DeactivatedQuoteExplanation, {
    shipmentQuote: graphql`
        fragment DeactivatedQuoteExplanation_shipmentQuote on ShipmentQuote {
            serviceMethod {
                serviceMethodType
                region {
                    regionBoundary {
                        locations {
                            state
                            zipCode
                            country: displayCountry
                        }
                    }
                }
            }
        }
    `,
});
